import { LocationOptionAllValue } from '../enum/LocationOptionAllValue';
import { CustomAny } from '../../../types/generics';

export class LocationOptionValueService {
  static isAllLocationValue(value: CustomAny): boolean {
    return Object.values(LocationOptionAllValue).includes(value);
  }
}
